import logger from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import { Env } from "../common/constants";
import rootReducer from "./root.reducer";

// Create persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["login", "verifyEmail"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      ...(Env.MODE !== "production" ? [logger] : []),
    ),
  devTools: Env.MODE !== "production",
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
